export default "__VITE_ASSET__DMyWyzNZ__"